import { componentsRegistry } from './registry';
import { NumberField } from '@/ui/fields/NumberField';
import { QuaternionField } from '@/ui/fields/QuaternionField';
import { StringField } from '@/ui/fields/StringField';
import { Vector3Field } from '@/ui/fields/Vector3Field';
import { Quaternion, Vector3 } from 'three';
import z from 'zod';

export const stringSchema = z.string();
componentsRegistry.add(stringSchema, {
  component: StringField,
});

export const numberSchema = z.number();
componentsRegistry.add(numberSchema, {
  component: NumberField,
});

// TODO: encode to [x, y, z] and [x, y, z, w] when serializing to JSON
/**
 * Represents a 3D vector (x, y, z). Accepts either [x, y, z] or { x, y, z }
 * and normalizes to { x, y, z }.
 */
export const Vec3Schema = z.union([
  z
    .tuple([z.number(), z.number(), z.number()])
    .transform(([x, y, z]) => new Vector3(x, y, z)),
  z
    .object({
      x: z.number(),
      y: z.number(),
      z: z.number(),
    })
    .transform(({ x, y, z }) => new Vector3(x, y, z)),
]);
componentsRegistry.add(Vec3Schema, {
  component: Vector3Field,
});

/**
 * Represents a quaternion (x, y, z, w). Accepts either [x, y, z, w] or
 * { x, y, z, w } and normalizes to { x, y, z, w }.
 */
export const QuaternionSchema = z.union([
  z
    .tuple([z.number(), z.number(), z.number(), z.number()])
    .transform(([x, y, z, w]) => new Quaternion(x, y, z, w)),
  z
    .object({
      x: z.number(),
      y: z.number(),
      z: z.number(),
      w: z.number(),
    })
    .transform(({ x, y, z, w }) => new Quaternion(x, y, z, w)),
]);
componentsRegistry.add(QuaternionSchema, {
  component: QuaternionField,
});
